

































































































































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import {
    DEFAULT_NETWORK_NAME,
    DEFAULT_NETWORK,
    HAS_SUBNET,
    CURRENT_SUBNET,
} from '@/store/modules/network/network'
import Loader from '@/components/misc/Loader.vue'
import CopyText from '@/components/misc/CopyText.vue'
import { toDCM } from '@/helper'

@Component({
    components: { Loader, CopyText },
    filters: { toDCM },
})
export default class RecentBlocks extends Vue {
    // created() {
    //     if (
    //         window.location.href.includes('blockchain') ||
    //         localStorage.getItem('isTSP')
    //     ) {
    //         this.forTSP = true
    //     }
    // }
    get currentActChainID() {
        return DEFAULT_NETWORK.ACTCHAINID
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }

    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }
    get transactions(): EVMBlockQueryResponse[] {
        return this.$store.state.Transactions.evmTxs
    }

    shortenText(source: string, index1: number, index2: number) {
        if (index2 >= source.length) return source

        return `${source.substring(0, index1)}...${source.substring(
            source.length - index2,
            source.length
        )}`
    }

    get blocks(): EVMBlockQueryResponse[] {
        const data = this.$store.state.Blocks.evmBlocks.sort(
            (a: EVMBlockQueryResponse, b: EVMBlockQueryResponse) => {
                return parseInt(b.blockNumber) - parseInt(a.blockNumber)
            }
        )
        const unique: any = [
            ...new Map(data.map((m: any) => [m.blockNumber, m])).values(),
        ]
        return unique
    }
}
